import { render, staticRenderFns } from "./FilterAge.vue?vue&type=template&id=3dfe0854&scoped=true&lang=pug&"
import script from "./FilterAge.vue?vue&type=script&lang=js&"
export * from "./FilterAge.vue?vue&type=script&lang=js&"
import style0 from "./FilterAge.vue?vue&type=style&index=0&id=3dfe0854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe0854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VMenu,VSpacer,VTextField})
